export function isEmailValid(email: string): boolean 
{
    // Basic regular expression pattern for validating emails
    const emailPattern = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/
    return emailPattern.test(email)
}